import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';
import styled from 'styled-components';
import "./assets/css/reset.css";
import { DiagnosisContainer } from './pages';
import { inject, observer } from 'mobx-react';

const App = inject("CommonStore")(observer((props)  => {
    return (
        <Wrap>
            <Switch>
                <Route path="/" component={DiagnosisContainer}/>
             </Switch>
        </Wrap>
    );
}));

const Wrap = styled.div`
    width: 100vw;
    overflow-x: hidden;
    min-width: 320px;
`;

export default App;
